import pathify from 'vuex-pathify'

pathify.options.deep = 2

export default pathify
